import { initializeApp } from 'firebase/app'
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics'
import { getPerformance } from 'firebase/performance'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
let analytics: any = null
let trackEvent: any = function () {}
let perf: any = null

if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app)

        perf = getPerformance(app)

        trackEvent = (eventname: string, eventParams = {}) => {
          logEvent(analytics, eventname, {
            page_href: window.location.href,
            ...eventParams,
          })
        }
      } else {
        console.warn('Firebase Analytics is not supported in this environment.')
      }
    })
    .catch((error) => {
      console.error('Error checking Firebase Analytics support:', error)
    })
}

export { app, analytics, trackEvent, perf }
